import { useCallback, useEffect, useState } from 'react';
import {
  disablePlatformUser,
  listPlatformUsers,
  type TenantPoolUser,
} from '../../lib/witness-api';

export function PlatformUsersPage() {
  const [users, setUsers] = useState<readonly TenantPoolUser[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [busyUserId, setBusyUserId] = useState<string | null>(null);
  const reload = useCallback(() => listPlatformUsers().then(setUsers).catch((cause: unknown) => setError(message(cause))), []);

  useEffect(() => { void reload(); }, [reload]);

  async function disable(user: TenantPoolUser) {
    if (!window.confirm(`Disable ${user.email} globally? All active sessions will end immediately.`)) return;
    setBusyUserId(user.id); setError(null);
    try { await disablePlatformUser(user.email); await reload(); }
    catch (cause) { setError(message(cause)); }
    finally { setBusyUserId(null); }
  }

  return <div className="flex flex-col gap-8">
    <div>
      <h1 className="font-serif text-2xl tracking-tight text-neutral-900">Users</h1>
      <p className="mt-1 text-sm text-neutral-600">Manage tenant-pool identities across the platform.</p>
    </div>
    {error && <p className="text-sm text-red-700">{error}</p>}
    {users.length === 0 ? <p className="text-sm text-neutral-500">No users.</p> :
      <table className="min-w-full text-sm"><thead><tr className="border-b text-left text-xs uppercase tracking-wider text-neutral-500"><th className="py-2">Email</th><th>Created</th><th>Status</th><th><span className="sr-only">Actions</span></th></tr></thead>
        <tbody>{users.map((user) => <tr key={user.id} className="border-b border-neutral-100"><td className="py-2">{user.email}</td><td>{new Date(user.createdAtMs).toISOString()}</td><td>{user.disabledAtMs === null ? 'Active' : 'Disabled'}</td><td className="text-right">{user.disabledAtMs === null && <button type="button" disabled={busyUserId !== null} onClick={() => void disable(user)} className="text-red-700 hover:underline disabled:opacity-50">{busyUserId === user.id ? 'Disabling…' : 'Disable globally'}</button>}</td></tr>)}</tbody>
      </table>}
  </div>;
}

function message(error: unknown): string {
  return error instanceof Error ? error.message : 'Request failed';
}
